import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        marginTop: 20
    },
    header: {
        paddingVertical: 25,
        backgroundColor: "#e1e1e1"
    },
    title: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 5
    },
    contentImgsCoins: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginTop: 28
    },
    imgCoins: {
        width: 50,
        height: 50
    },
    contentPrice: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 25,
        marginTop: 10,
    },
    textPriceLeft: {
        fontSize: 16
    },
    textPriceRight: {
        fontSize: 16,
        textAlign: 'right'
    },
    price: {
        fontSize: 16,
        fontWeight: 'bold',
    },
    priceSecondary: {
        fontSize: 14,
        fontWeight: '400',
        color: '#656565',
        textAlign: 'right'
    },
    hr: {
        height: 1,
        marginTop: 18,
        backgroundColor: "#2C2C2E",
        opacity: 0.5,
    },
    contentCheckbox: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '90%',
        marginTop: 10
    },
    confirmDataRow: {
        flexDirection: 'row',
        marginVertical: 5,
    },
    confirmDataRowColTitle: {
        flex: 0.5,
        fontWeight: '700',
        fontSize: 16,
        color: '#333333'
    },
    confirmDataRowColText: {
        flex: 0.5,
        fontWeight: '400',
        fontSize: 16,
        color: '#656565',
        textAlign: 'right'
    },
    contentBtn: {
        position: 'absolute',
        bottom: 50,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    }
});

export default styles;
